import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import PassWord from '@/views/User/PassWord.vue'
import { getCurrentTimestamp } from '@/utils/solt/timestamp'
import { sortByMd5WithSalt } from '@/utils/solt'
import { getUserInfo } from '@/api/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const forcePwdVisible = ref(false)
let checking = false

const syncForcePasswordFlag = (mustChange: boolean) => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('UserInfo') || '{}')
    userInfo.must_change_password = mustChange ? 1 : 0
    localStorage.setItem('UserInfo', JSON.stringify(userInfo))
  } catch (e) {}
  forcePwdVisible.value = mustChange
}

/** 刷新/进入业务页时，请求后端核对密码是否仍为 123456 */
const checkForceChangePassword = async () => {
  if (checking) return
  const token = localStorage.getItem('token')
  if (!token) {
    forcePwdVisible.value = false
    return
  }
  // 登录页不弹
  if (route.path === '/login' || route.name === 'login') return

  // 先用本地缓存快速弹出，再以后端结果为准
  try {
    const cached = JSON.parse(localStorage.getItem('UserInfo') || '{}')
    if (cached?.must_change_password == 1) {
      forcePwdVisible.value = true
    }
  } catch (e) {}

  checking = true
  try {
    const time = await getCurrentTimestamp()
    const obj = { timestamp: time }
    const sign = await sortByMd5WithSalt(obj)
    const res: any = await getUserInfo({ timestamp: time, sign })
    const user = res?.data?.user || res?.user
    const codeOk = res?.code == 200 || res?.code === undefined
    if (codeOk && user) {
      const mustChange = user.must_change_password == 1
      syncForcePasswordFlag(mustChange)
    }
  } catch (e) {
    console.error('检查简易密码失败', e)
  } finally {
    checking = false
  }
}

const onForcePwdClose = () => {
  forcePwdVisible.value = false
}

const onForcePwdSuccess = () => {
  syncForcePasswordFlag(false)
}

onMounted(() => {
  checkForceChangePassword()
})

watch(
  () => route.fullPath,
  () => {
    checkForceChangePassword()
  },
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(PassWord, {
      visible: forcePwdVisible.value,
      force: true,
      onClose: onForcePwdClose,
      onSuccess: onForcePwdSuccess
    }, null, 8, ["visible"])
  ], 64))
}
}

})